import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import { Modal } from "bootstrap";
import CheckIcon from "@mui/icons-material/Check";
// css
import "./Inspectionlist.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import searchbtn from "../../../Assets/images/search.svg";
import deleteimg from "../../../Assets/images/delete-img.png";
// custom imports
import { hideLoader, showLoader } from "../../../Redux/Slice/Loader/loaderSlice";
import showToast from "../../../Utils/Toast/ToastNotification";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import Pagination from "../../Pagination/Pagination";
import inspectionService from "../../../Services/inspectionService/inspectionService";
import userManagementService from "../../../Services/UserManagement/UserManagementService";
import projectManagementService from "../../../Services/projectManagementService/projectManagementService"

const Inspectionlist = () => {
  const inspectionDate_from = useRef(null);
  const inspectionDate_to = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("inspection_date");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [inspection, setInspection] = useState([]);
  const [users, setUsers] = useState([]);
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [filters, setFilters] = useState({
    inspectionDate_from: "",
    inspectionDate_to: "",
    status: "",
    inspector_id: [],
    project_type: "",
    page: 1,
    limit: 10,
  });
  const [inspectionStatus, setInspectionStatus] = useState(null);
  const [inspectionId, setIinspectionId] = useState(null);
  const [projectTypes, setProjectTypes] = useState([]);

  const user_id = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.userData?.id
  );

  const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token)

  const handleFocus = (ref) => {
    if (ref.current) {
      ref.current.showPicker?.(); // Open date picker if supported
    }
  };

  const modalRef = useRef(null);
  const openModal = () => {
    if (modalRef.current) {
      const modalInstance = new Modal(modalRef.current, { backdrop: "static" });

      const oldInstance = Modal.getInstance(modalRef.current);
      if (oldInstance) {
        oldInstance.dispose();
      }
      const newInstance = new Modal(modalRef.current, { backdrop: "static" });
      newInstance.show();
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setPage(0);
  };

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [id]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    getInpsectionList();
  };

  const handleClearFilter = (e) => {
    e.preventDefault();

    setFilters({
      inspectionDate_from: "",
      inspectionDate_to: "",
      status: "",
      inspector_id: [],
      project_type: "",
      page: page + 1,
      limit: rowsPerPage,
    });
    setIsFilterCleared(true);
    setSearchQuery("");
    if (inspectionDate_from.current) inspectionDate_from.current.value = "";
    if (inspectionDate_to.current) inspectionDate_to.current.value = "";
    // getInpsectionList();
  };

  const getInpsectionList = async () => {
    dispatch(showLoader());
    const params = {
      search: searchQuery || "",
      page: page + 1,
      limit: rowsPerPage,
      sort_by: `"${sortBy}"`,
      sort_order: sortOrder,
      inspectionDate_from: filters.inspectionDate_from,
      inspectionDate_to: filters.inspectionDate_to,
      status: filters.status,
      inspector_id: filters.inspector_id.map((user) => user.id).join(","),
      is_archived: showArchived ? "" : "false",
      project_type: filters.project_type
    };
    try {
      const response = await inspectionService.getInspections(params, token);
      if (response?.data?.statusCode == 200) {
        const inspectionList = response?.data?.body?.data?.inspection || [];
        const totalItems = response?.data?.body?.data?.total || 0;

        if (inspectionList.length === 0 && page > 0) {
          setPage((prev) => prev - 1);
        } else {
          setInspection(inspectionList);
          setTotalRecords(totalItems);
        }
      } else {
        showToast("error", response.data.body?.message);
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleArchive = async () => {
    try {
      showLoader(true);
      const params = {
        inspection_id: selectedId,
        last_updated_by: user_id,
      };
      await inspectionService.archiveInspection(params, token);

      showToast("success", "Inspection archived successfully");
      await getInpsectionList();
    } catch (error) {
      await HandleApiError(error);
    } finally {
      showLoader(false);
    }
  };

  const handleInspector = (event, newValue) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      inspector_id: newValue, // KEEP AS ARRAY
    }));
  };

  const handleDelete = async () => {
    try {
      const params = {
        inspection_id: selectedId,
        deleted_by: user_id,
      };
      await inspectionService.deleteInspection(params, token);
      showToast("success", "Inspection Deleted successfully");
      await getInpsectionList();
    } catch (error) {
      await HandleApiError(error);
    }
  };

  const getAllUser = async () => {
    try {
      const response = await userManagementService.getAllUserList(token);
      if (response?.data?.statusCode === 200) {
        setUsers(response.data?.body?.data?.users);
      } else {
        showToast("error", response.data.body.message);
      }
    } catch (error) {
      await HandleApiError(error);
    }
  };

  const cloneInspection = async () => {
    try {
      const response = await inspectionService.cloneInspection({
        id: selectedId,
      }, token);
      if (response?.data.statusCode === 200) {
        showToast("success", response.data.body.message);
        getInpsectionList();
      } else {
        showToast("error", response.body.message);
      }
      await getInpsectionList();
    } catch (error) {
      await HandleApiError(error);
    }
  };

  const getProjectTypes = async () => {
    try {
      const response = await projectManagementService.getProjectTypes(token);
      if (response?.data?.statusCode === 200) {
        setProjectTypes(response.data.body.data.states);
      } else {
        showToast("error", response.data.body.message);
      }
    } catch (error) {
      await HandleApiError(error);
    }
  };

  // useEffect
  useEffect(() => {
    if (isFilterCleared) {
      getInpsectionList();
      setIsFilterCleared(false);
    }
  }, [isFilterCleared]);

  useEffect(() => {
    getInpsectionList();
  }, [debouncedSearch, page, rowsPerPage, sortBy, sortOrder]);

  useEffect(() => {
    getProjectTypes()
    getAllUser();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  useEffect(() => {
    getInpsectionList();
  }, [showArchived]);

  return (
    <div className="main-inner-block">
      <div className="content">
        <div className="d-flex align-items-center justify-content-between mb-4 block-one gap-3">
          <div className="heading-content ms-0 mt-0">Inspections List</div>
          <div className="heading-content mt-0">
            <button
              className="green-btn green-signin addnewuser"
              onClick={() => navigate("/add-inspection")}
            >
              + Add Inspections
            </button>
          </div>
        </div>
        <div className="white-box bg-box-mob">
          <div className="inner-content-block">
            <div className="listing-title-block d-flex justify-content-between">
              <div className="box-listing-title">
                Inspections List
                <span className="d-block">
                  Showing a list of Inspections List{" "}
                </span>
              </div>
              <div className="searchbar-btn d-flex align-items-center gap-4">
                <div className="toggle-archive d-flex align-items-center">
                  <label
                    className="form-check-label me-2"
                    htmlFor="archiveToggle"
                  >
                    Show Archived
                  </label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="archiveToggle"
                      checked={showArchived}
                      onChange={(e) => setShowArchived(e.target.checked)}
                    />
                  </div>
                </div>
                <div className="input-search-box position-relative">
                  <input
                    type="text"
                    id="name"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <div className="searchbtn">
                    <img src={searchbtn} alt="searchbtn"></img>
                  </div>
                  {searchQuery && (
                    <button
                      className="clear-btn"
                      onClick={() => setSearchQuery("")}
                    >
                      ✖
                    </button>
                  )}
                </div>
                <div className="filter d-flex align-items-center gap-4">
                  <a
                    className="filter-inner"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={(e) => {
                      e.preventDefault();
                      openModal();
                    }}
                  >
                    <span className="me-2">
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 10.332H15M2.5 5.33203H17.5M7.5 15.332H12.5"
                          stroke="#475467"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Filter
                  </a>
                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content">
                        <div className="text-end">
                          <button
                            type="button"
                            class="btn-close "
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>

                        <div>
                          <h1
                            class="modal-title fs-5 text-center filter-title"
                            id="exampleModalLabel"
                          >
                            Inspection Management Filter
                          </h1>
                        </div>
                        <div class="modal-body">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              getInpsectionList();
                            }}
                          >
                            <div class="mb-3">
                              <label for="inspector_id" class="form-label">
                                Inspector
                              </label>
                              <Autocomplete
                                className="autocomplete-box position-relative"
                                name="inspector_id"
                                multiple
                                options={users}
                                getOptionLabel={(option) => option?.name || ""}
                                disableCloseOnSelect
                                value={filters.inspector_id}
                                onChange={handleInspector}
                                sx={{
                                  m: 1,
                                  // width: 375,
                                  "& .MuiOutlinedInput-root": {
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "1px solid #e6e6e6 !important",
                                    },
                                    "&:before, &:after": {
                                      border: "1px solid #e6e6e6 !important",
                                    },
                                    "&.Mui-focused:after": {
                                      border: "1px solid #e6e6e6 !important",
                                    },
                                  },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    className="coordinator"
                                    placeholder={
                                      filters.inspector_id && filters.inspector_id.length > 0
                                        ? ""
                                        : "Select Inspector"
                                    }
                                  />
                                )}
                                renderOption={(props, option, { selected }) => (
                                  <MenuItem
                                    {...props}
                                    key={option.user_id}
                                    sx={{ justifyContent: "space-between" }}
                                  >
                                    {`${option.name}`}
                                    {selected ? (
                                      <CheckIcon color="info" />
                                    ) : null}
                                  </MenuItem>
                                )}
                              />
                            </div>

                            <div className="mb-3">
                              <label for="project_type" class="form-label">
                                Project Types
                              </label>
                              <select
                                className="form-select"
                                id="project_type"
                                value={filters.project_type}
                                onChange={handleFilterChange}
                              >
                                <option disabled value="">
                                  Select Project Type
                                </option>
                                {Array.isArray(projectTypes) &&
                                  projectTypes.length > 0 ? (
                                  projectTypes.map((project_type) => (
                                    <option
                                      key={project_type.name}
                                      value={project_type.name}
                                    >
                                      {project_type.name}
                                    </option>
                                  ))
                                ) : (
                                  <option disabled>
                                    No Project Types Available
                                  </option>
                                )}
                              </select>
                            </div>

                            <div class="mb-3">
                              <label for="status" class="form-label">
                                Status
                              </label>
                              <select
                                className="form-select"
                                id="status"
                                value={filters.status}
                                onChange={handleFilterChange}
                              >
                                <option disabled value="">
                                  Select Status{" "}
                                </option>
                                <option value="Scheduled">Scheduled </option>
                                <option value="Not Started">Not Started</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Complete">Complete</option>
                                <option value="Archive">Archive</option>
                              </select>
                            </div>

                            <div class="mb-3">
                              <label className="form-label">Date</label>
                              <div className="d-flex gap-2">
                                <input
                                  type="date"
                                  className="form-control"
                                  id="inspectionDate_from"
                                  name="inspectionDate_from"
                                  onChange={handleFilterChange}
                                  ref={inspectionDate_from}
                                  onClick={() =>
                                    handleFocus(inspectionDate_from)
                                  }
                                  placeholder="From"
                                />{" "}
                                <span>-</span>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="inspectionDate_to"
                                  name="inspectionDate_to"
                                  ref={inspectionDate_to}
                                  onChange={handleFilterChange}
                                  onClick={() => handleFocus(inspectionDate_to)}
                                  placeholder="To"
                                />
                              </div>
                            </div>
                            <div className="text-center">
                              <button
                                type="submit"
                                class="green-btn updt-button"
                                data-bs-dismiss="modal"
                                onClick={(e) => handleFilterSubmit(e)}
                              >
                                Filter
                              </button>
                              <button
                                type="submit"
                                class="green-btn updt-button ms-2"
                                data-bs-dismiss="modal"
                                onClick={handleClearFilter}
                              >
                                Clear Filter
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-block ">
              <table class="table">
                <thead class="table-headers">
                  <tr>
                    <th>Inspection Title</th>
                    <th>Project Type</th>
                    <th onClick={() => handleSort("project_address")}>
                      Project Address
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th onClick={() => handleSort("inspection_date")}>
                      Date
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th>Inspector</th>
                    <th onClick={() => handleSort("status")}>
                      Status
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {" "}
                  {inspection.length > 0 ? (
                    inspection.map((inspection, index) => (
                      <tr key={inspection.id}>
                        <td>
                          <a
                            className="name-email-text"
                            onClick={() => navigate(`/start-inspection/${inspection.template_id}`, {
                              state: {
                                inspectionId: inspection.id,
                              },
                            })}
                          >
                            {inspection.inspection_name}
                          </a>
                        </td>
                        <td>{inspection.name}</td>
                        <td>
                          {" "}
                          {inspection.project_streetaddress}{" "}
                          {inspection.porject_suburb} {inspection.state_name}{" "}
                          {inspection.project_postCode}
                        </td>
                        <td
                          style={{
                            textAlign: !inspection.inspection_date
                              ? "center"
                              : "left",
                          }}
                        >
                          {inspection.inspection_date
                            ? new Date(
                              inspection.inspection_date
                            ).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>
                          {inspection.inspectors &&
                            inspection.inspectors.length > 0
                            ? inspection.inspectors
                              .map((inspector) =>
                                inspector?.first_name || inspector?.last_name
                                  ? `${inspector.first_name || ""} ${inspector.last_name || ""
                                    }`.trim()
                                  : null
                              )
                              .filter(Boolean) // remove nulls
                              .join(", ") || "No Inspectors"
                            : "No Inspectors"}
                        </td>
                        {/* <td>
                          {inspection.inspectors.length > 0
                            ? inspection.inspectors
                              .map(
                                (inspectors) =>
                                  `${inspectors.first_name} ${inspectors.last_name}`
                              )
                              .join(", ")
                            : "No Inspectors"}
                        </td> */}
                        <td>{inspection.status}</td>

                        <td>
                          <div className="d-flex gap-3">
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/view-inspection/${inspection.id}`)
                              }
                            >
                              <i className="fas fa-eye me-2"></i>
                              <span className="tooltip-text">View</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/update-inspection/${inspection.id}`)
                              }
                            >
                              <i className="fas fa-pencil-alt me-2"></i>
                              <span className="tooltip-text">Update</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#deletemodal"
                              onClick={() => setSelectedId(inspection.id)}
                            >
                              <i className="fas fa-trash me-2"></i>
                              <span className="tooltip-text">Delete</span>
                            </a>

                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#cloneModel"
                              onClick={() => setSelectedId(inspection.id)}
                            >
                              <i class="fa-solid fa-clone"></i>
                              <span className="tooltip-text">Clone</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#archiveemodal"
                              onClick={() => setSelectedId(inspection.id)}
                            >
                              <i class="fa fa-archive" aria-hidden="true"></i>
                              <span className="tooltip-text">Archive</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (inspection.status === "Complete") {
                                  navigate(`/start-inspection/${inspection.template_id}`, {
                                    state: {
                                      inspectionId: inspection.id,
                                      start_time: new Date().toISOString(),
                                    },
                                  });
                                } else {

                                  setSelectedId(inspection.template_id);
                                  setIinspectionId(inspection.id);
                                  setInspectionStatus(inspection.status);

                                  const modal = new Modal(document.getElementById('inspectionmodal'));
                                  modal.show();
                                }
                              }}

                            > {
                                inspection.status === "Complete" ?
                                  <>
                                    <i className="fa-solid fa-file-pen"></i>
                                    <span className="tooltip-text">Update Inspection</span>
                                  </> :
                                  <>
                                    <i className="fas fa-plus me-2"></i>
                                    <span className="tooltip-text">Start Inspection</span>
                                  </>
                              }

                            </a>

                            {/* Start Inspection Modal */}
                            <div
                              className="modal fade"
                              id="inspectionmodal"
                              tabindex="-1"
                              aria-labelledby="inspectionmodallabel"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog modal-dialog-centered delete-modal">
                                <div className="modal-content">
                                  <div className="modal-body">
                                    <div className="text-center delete-img-blk">
                                      <img src={deleteimg} alt="delete-img" />
                                    </div>
                                    {
                                      inspection.status === "Complete" ?
                                        (
                                          <div className="ques-title text-center">
                                            Inspection already Done.
                                            <p className="m-0">Do you want to update the inspection?</p>
                                          </div>
                                        ) :
                                        (
                                          <div className="ques-title text-center">

                                            Are you sure?
                                            <p className="m-0">
                                              Are you sure you want to start the inspection?
                                            </p>
                                          </div>
                                        )
                                    }
                                  </div>
                                  <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                    <button
                                      type="button"
                                      className="gray-outline-btn"
                                      data-bs-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="orange-btn"
                                      data-bs-dismiss="modal"
                                      onClick={() => {
                                        navigate(`/start-inspection/${selectedId}`, {
                                          state: { inspectionId: inspectionId, start_time: new Date().toISOString() }
                                        });
                                      }}
                                    >
                                      {
                                        inspectionStatus === "Complete" ?
                                          "Update Inspection" :
                                          "Start Inspection"
                                      }
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Inspection found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>


            {/* responsive */}
            <div className="mobile-table-card d-block d-md-none">
              {inspection?.length > 0
                ? (
                  inspection.map((inspection) => (
                    <div key={inspection.id} className="user-card">
                      <div className="data-card mb-3 p-3 border rounded">
                        <div className="mb-2">
                          <strong>Inspection Title:</strong>{inspection.inspection_name}
                        </div>
                        <div className="mb-2">
                          <strong>Project Address:</strong>{inspection.project_streetaddress}
                        </div>
                        <div className="mb-2">
                          <strong>Date:</strong>{inspection.inspection_date
                            ? new Date(
                              inspection.inspection_date
                            ).toLocaleDateString()
                            : "-"}
                        </div>
                        <div className="mb-2">
                          <strong>Inspector:</strong>{inspection.inspectors &&
                            inspection.inspectors.length > 0
                            ? inspection.inspectors
                              .map((inspector) =>
                                inspector?.first_name || inspector?.last_name
                                  ? `${inspector.first_name || ""} ${inspector.last_name || ""
                                    }`.trim()
                                  : null
                              )
                              .filter(Boolean) // remove nulls
                              .join(", ") || "No Inspectors"
                            : "No Inspectors"}
                        </div>
                        <div className="mb-2">
                          <strong>Status:</strong>{inspection.status}
                        </div>


                        <div className="d-flex justify-content-end mt-3 gap-3">
                          <a
                            className="d-flex align-items-center text-decoration-none fonticon"
                            onClick={() =>
                              navigate(`/view-inspection/${inspection.id}`)
                            }
                          >
                            <i className="fas fa-eye me-2"></i>
                          </a>
                          <a
                            className="d-flex align-items-center text-decoration-none fonticon"
                            onClick={() =>
                              navigate(`/update-inspection/${inspection.id}`)
                            }
                          >
                            <i className="fas fa-pencil-alt me-2"></i>
                          </a>

                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#cloneModel"
                            onClick={() => setSelectedId(inspection.id)}
                          >
                            <i class="fa-solid fa-clone"></i>
                            <span className="tooltip-text">Clone</span>
                          </a>
                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#archiveemodal"
                            onClick={() => setSelectedId(inspection.id)}
                          >
                            <i class="fa fa-archive" aria-hidden="true"></i>
                            <span className="tooltip-text">Archive</span>
                          </a>

                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (inspection.status === "Complete") {
                                navigate(`/start-inspection/${inspection.template_id}`, {
                                  state: {
                                    inspectionId: inspection.id,
                                    start_time: new Date().toISOString(),
                                  },
                                });
                              } else {

                                setSelectedId(inspection.template_id);
                                setIinspectionId(inspection.id);
                                setInspectionStatus(inspection.status);

                                const modal = new Modal(document.getElementById('inspectionmodal1'));
                                modal.show();
                              }
                            }}

                          > {
                              inspection.status === "Complete" ?
                                <>
                                  <i className="fa-solid fa-file-pen"></i>
                                  <span className="tooltip-text">Update Inspection</span>
                                </> :
                                <>
                                  <i className="fas fa-plus me-2"></i>
                                  <span className="tooltip-text">Start Inspection</span>
                                </>
                            }

                          </a>

                          <div
                            className="modal fade"
                            id="inspectionmodal1"
                            tabindex="-1"
                            aria-labelledby="inspectionmodallabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered delete-modal">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="text-center delete-img-blk">
                                    <img src={deleteimg} alt="delete-img" />
                                  </div>
                                  {
                                    inspection.status === "Complete" ?
                                      (
                                        <div className="ques-title text-center">
                                          Inspection already Done.
                                          <p className="m-0">Do you want to update the inspection?</p>
                                        </div>
                                      ) :
                                      (
                                        <div className="ques-title text-center">

                                          Are you sure?
                                          <p className="m-0">
                                            Are you sure you want to start the inspection?
                                          </p>
                                        </div>
                                      )
                                  }
                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                  <button
                                    type="button"
                                    className="gray-outline-btn"
                                    data-bs-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="orange-btn"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                      navigate(`/start-inspection/${selectedId}`, {
                                        state: { inspectionId: inspectionId, start_time: new Date().toISOString() }
                                      });
                                    }}
                                  >
                                    {
                                      inspectionStatus === "Complete" ?
                                        "Update Inspection" :
                                        "Start Inspection"
                                    }
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  ))
                )
                : (
                  <div className="text-center">
                    No Template found
                  </div>
                )
              }
            </div>

            <div className="pagination-block">
              {
                <Pagination
                  count={totalRecords}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              }
            </div>
          </div>
        </div>

        {/* delete modal */}
        <div
          class="modal fade"
          id="deletemodal"
          tabindex="-1"
          aria-labelledby="deletemodalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered delete-modal">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center delete-img-blk">
                  <img src={deleteimg} alt="delete-img"></img>
                </div>
                <div className="ques-title text-center">
                  Are you sure ?
                  <p className="m-0">
                    Are you sure you really want to delete this record? This
                    process cannot be undone.
                  </p>
                  {/* <p className='m-0'>Please note that if the inspection is deleted, any related data to the inspection will also be deleted including any completed forms.</p> */}
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                <button
                  type="button"
                  class="gray-outline-btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  class="orange-btn"
                  data-bs-dismiss="modal"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* archive modal */}
        <div
          class="modal fade"
          id="archiveemodal"
          tabindex="-1"
          aria-labelledby="archiveemodalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered delete-modal">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center delete-img-blk">
                  <img src={deleteimg} alt="delete-img"></img>
                </div>
                <div className="ques-title text-center">
                  Are you sure ?
                  <p className="m-0">
                    Are you sure you really want to archive this record?
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                <button
                  type="button"
                  class="gray-outline-btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="orange-btn"
                  data-bs-dismiss="modal"
                  onClick={handleArchive}
                >
                  Archive
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* clone modall */}
        <div
          class="modal fade"
          id="cloneModel"
          tabindex="-1"
          aria-labelledby="deletemodalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered delete-modal">
            <div class="modal-content">
              <div class="modal-body">
                <div className="ques-title text-center">
                  Are you sure ?
                  <p className="m-0">
                    Do you want to clone the inspection record?
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                <button
                  type="button"
                  class="gray-outline-btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="orange-btn"
                  data-bs-dismiss="modal"
                  onClick={cloneInspection}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inspectionlist;
